import { type AlertProps, mkAlert } from './alertsTypes';

export const transformResponseToAlert = (response?: { data?: { resources?: AlertProps[] } } | null) =>
  response?.data?.resources?.map((data) => mkAlert(data));
